/* eslint-disable no-undef */
import axiosInstance from './axiosInstance';
import { getFormControlConfigs } from './extensionSync';

/**
 * Utility functions for wizard completion checking and management
 */

export const checkWizardCompletion = async () => {
  try {
    // Check localStorage flag
    const wizardCompleted = localStorage.getItem('applyease_wizard_completed');
    
    // Check form config (localStorage or Extension)
    const formConfig = await getFormControlConfigs();
    const hasFormConfig = !!(formConfig.defaultFields?.firstName || formConfig.inputFieldConfigs?.length > 0);
    
    // Check if resume exists (via API)
    let hasResume = false;
    try {
      const response = await axiosInstance.get('/resumes');
      const resumes = (response.data && response.data.items) || [];
      hasResume = resumes.length > 0;
    } catch (e) {
      console.warn('Failed to check resumes:', e);
    }
    
    // Check if user has settings (Filters) via API
    let hasFilters = false;
    try {
        const userResp = await axiosInstance.get('/user');
        const user = userResp.data;
        if (user.settings) {
            hasFilters = !!(
                user.settings.titleSkipWords?.length > 0 || 
                user.settings.titleFilterWords?.length > 0 || 
                user.settings.badWords?.length > 0 ||
                user.settings.titleSkipEnabled ||
                user.settings.titleFilterEnabled ||
                user.settings.badWordsEnabled
            );
        }
    } catch (e) {}

    // Also check extension for filters if backend check failed or as supplement
    if (!hasFilters && typeof chrome !== 'undefined' && chrome.runtime && chrome.runtime.sendMessage) {
        try {
            const resp = await new Promise((resolve) => {
                chrome.runtime.sendMessage({ action: 'getFilterSettings' }, (r) => {
                    if (chrome.runtime.lastError) resolve(null);
                    else resolve(r);
                });
            });
            if (resp) {
                hasFilters = !!(resp.titleSkipWords?.length > 0 || resp.titleFilterWords?.length > 0);
            }
        } catch(e) {}
    }
    
    // Overall completion check
    // We consider it complete if the flag is set OR if we have the critical pieces (Form Config + Resume)
    // Filters are optional-ish but good to have
    const isActuallyComplete = hasFormConfig && hasResume; // Reduced strictness for auto-detection

    return {
      completed: wizardCompleted === 'true' || isActuallyComplete,
      hasFormConfig,
      hasResume,
      hasFilters,
      isComplete: wizardCompleted === 'true' || isActuallyComplete
    };
  } catch (error) {
    console.error('Error checking wizard completion:', error);
    return {
      completed: false,
      hasFormConfig: false,
      hasResume: false,
      hasFilters: false,
      isComplete: false
    };
  }
};

export const getWizardCompletionPercentage = async () => {
  try {
    let completed = 0;
    const total = 4;
    
    // Fetch Data
    const formConfig = await getFormControlConfigs();
    
    let user = null;
    try {
        const u = await axiosInstance.get('/user');
        user = u.data;
    } catch (e) {}

    let resumes = [];
    try {
        const r = await axiosInstance.get('/resumes');
        resumes = (r.data && r.data.items) || [];
    } catch (e) {}

    // Step 1: Personal Info
    // Check backend first (most reliable)
    let hasPersonalInfo = !!(user?.first_name && user?.last_name);
    // Fallback to form config default fields
    if (!hasPersonalInfo && formConfig.defaultFields?.firstName) {
        hasPersonalInfo = true;
    }
    if (hasPersonalInfo) completed++;
    
    // Step 2: Resume
    if (resumes.length > 0) completed++;
    
    // Step 3: Form Control
    // Check formConfig (from extension/localstorage)
    if (formConfig.inputFieldConfigs?.length > 0 || formConfig.radioButtons?.length > 0 || formConfig.dropdowns?.length > 0) {
      completed++;
    }
    
    // Step 4: Filters
    let hasFilters = false;
    // Check backend
    if (user?.settings) {
        hasFilters = !!(
            user.settings.titleSkipWords?.length > 0 || 
            user.settings.titleFilterWords?.length > 0 || 
            user.settings.badWords?.length > 0 ||
            user.settings.titleSkipEnabled
        );
    }
    // Check extension
    if (!hasFilters && typeof chrome !== 'undefined' && chrome.runtime) {
        // ... (existing extension check logic if needed, but backend sync is preferred)
    }
    
    if (hasFilters) completed++;
    
    return {
      percentage: Math.round((completed / total) * 100),
      completed,
      total
    };
  } catch (error) {
    console.error('Error calculating completion:', error);
    return { percentage: 0, completed: 0, total: 4 };
  }
};

export const resetWizard = () => {
  localStorage.removeItem('applyease_wizard_completed');
};




